import { render, staticRenderFns } from "./job-view.vue?vue&type=template&id=b65213c6&scoped=true&"
import script from "./job-view.vue?vue&type=script&lang=js&"
export * from "./job-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65213c6",
  null
  
)

export default component.exports